import React, { useState } from "react";
import ReactDOM from "react-dom/client";

type Notice = {
  show: boolean;
  success: boolean;
  message: string;
};

const NoticeComponent = ({ data }: { data: Notice }) => {
  const className = data.success ? "bg-green-100" : "bg-red-100";

  return (
    <div className={`${className} px-6 py-3 rounded-md text-sm`}>
      {data.message}
    </div>
  );
};

const PurchaseForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [notice, setNotice] = useState<Notice>({
    show: false,
    success: false,
    message: "",
  });

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (name == "" || phone == "") {
      setNotice({
        show: true,
        success: false,
        message: "Заполните поля Имя и Телефон",
      });
      return;
    }

    const response = await fetch("/api/purchases", {
      method: "POST",
      body: JSON.stringify({ name, phone, message, source: window.location.href }),
    });

    const result = await response.json();

    if (result.ok) {
      setName("");
      setPhone("");
      setMessage("");

      setNotice({
        show: true,
        success: true,
        message: "Спасибо за обращение, мы скоро с вами свяжемся",
      });
    }
  };

  return (
    <div className="">
      <form className="" onSubmit={submit}>
        <div className="mb-4">
          <label htmlFor="name" className="block font-medium text-gray-600">
            Ваше имя
          </label>
          <input
            type="text"
            id="name"
            name="name"
            className="mt-1 p-2 w-full border-b rounded-md"
            placeholder="Укажите имя"
            onChange={(e) => {
              setName(e.target.value);
            }}
            value={name}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="phone" className="block font-medium text-gray-600">
            Телефон
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            className="mt-1 p-2 w-full border-b rounded-md"
            placeholder="+7 (000) 000-00-00"
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            value={phone}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="message" className="block font-medium text-gray-600">
            Комментарий
          </label>
          <input
            type="text"
            id="message"
            name="phone"
            className="mt-1 p-2 w-full border-b rounded-md"
            placeholder="Хочу подобрать фундамент"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            value={message}
          />
        </div>
        <div className="py-5 text-sm">
          Нажимая на кнопку, вы соглашаетесь с Условиями
          использования и Политикой конфиденциальности
        </div>
        <div className="mt-4 flex flex-col lg:flex-row gap-3">
          <div className="w-full lg:w-1/2">
            <button
              type="submit"
              className="rounded-full border border-gray-600 py-4 px-6 text-gray-600"
            >
              Отправить заявку
            </button>
          </div>
          <div className="w-full lg:w-1/2">
            {notice.show && <NoticeComponent data={notice} />}
          </div>
        </div>
      </form>
    </div>
  );
};

const container = document.getElementById("purchase-form");
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(<PurchaseForm />);
}
